import { useCallback, useEffect, useState } from "react";
import ApiService from "../services/api.service";

export type FavoriteTemplateStyleType = "email" | "inApp" | "push";

export type FavoriteTemplateStyles = {
  email?: string;
  inApp?: string;
  push?: string;
};

const readFromAccount = (data: any): FavoriteTemplateStyles => {
  const raw = data?.[0]?.favoriteTemplateStyles ?? data?.favoriteTemplateStyles;
  if (!raw || typeof raw !== "object") return {};
  const out: FavoriteTemplateStyles = {};
  if (typeof raw.email === "string") out.email = raw.email;
  if (typeof raw.inApp === "string") out.inApp = raw.inApp;
  if (typeof raw.push === "string") out.push = raw.push;
  return out;
};

export const useFavoriteTemplateStyles = () => {
  const [favorites, setFavorites] = useState<FavoriteTemplateStyles>({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await ApiService.get({ url: "/accounts" });
        if (!cancelled) setFavorites(readFromAccount(data));
      } catch {
        // unauthenticated or transient; treat as no favorites
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const setFavorite = useCallback(
    async (type: FavoriteTemplateStyleType, styleKey: string | null) => {
      const { data } = await ApiService.patch<{
        favoriteTemplateStyles: FavoriteTemplateStyles | null;
      }>({
        url: "/accounts/favorite-template-style",
        options: { type, styleKey },
      });
      setFavorites(data?.favoriteTemplateStyles ?? {});
    },
    []
  );

  return { favorites, loaded, setFavorite };
};
